import type { AuditTrailStep } from './model'

export const STEPS_WITH_TAGGING: Array<{ label: string; value: AuditTrailStep }> = [
  {
    label: 'Clustering',
    value: 'clustering',
  },
  {
    label: 'Classification',
    value: 'classification',
  },
  {
    label: 'Data Extraction',
    value: 'data',
  },
  {
    label: 'Tagging',
    value: 'tagging',
  },
  {
    label: 'Matching',
    value: 'patient',
  },
  {
    label: 'Payment Deposit',
    value: 'eob-payment-deposit',
  },
  {
    label: 'Duplication',
    value: 'eob-duplication',
  },
  {
    label: 'EOB Processing',
    value: 'eob-processing',
  },
  {
    label: 'Document',
    value: 'document',
  },
] as const

export const STEPS: Array<{ label: string; value: AuditTrailStep }> = [
  {
    label: 'Clustering',
    value: 'clustering',
  },
  {
    label: 'Classification',
    value: 'classification',
  },
  {
    label: 'Data Extraction',
    value: 'data',
  },
  {
    label: 'Matching',
    value: 'patient',
  },
  {
    label: 'Document',
    value: 'document',
  },
] as const

export const EOB_STEPS: Array<{ label: string; value: AuditTrailStep }> = [
  {
    label: 'Clustering',
    value: 'clustering',
  },
  {
    label: 'Classification',
    value: 'classification',
  },
  {
    label: 'Payment Deposit',
    value: 'eob-payment-deposit',
  },
  {
    label: 'Duplication',
    value: 'eob-duplication',
  },
  {
    label: 'EOB Processing',
    value: 'eob-processing',
  },
  {
    label: 'Document',
    value: 'document',
  },
] as const

export const EOB_NON_FINANCIAL_STEPS: Array<{ label: string; value: AuditTrailStep }> = [
  {
    label: 'Clustering',
    value: 'clustering',
  },
  {
    label: 'Classification',
    value: 'classification',
  },
  {
    label: 'Duplication',
    value: 'eob-duplication',
  },
  {
    label: 'EOB Processing',
    value: 'eob-processing',
  },
  {
    label: 'Document',
    value: 'document',
  },
] as const
